import {
  TAvatar,
  addPictureRoute,
  apiPrefix,
  avatarBrainService,
  avatarRouteDelete,
  avatarRouteList,
  avatarRouteUpdate,
  loginRoute,
  platformAvatarsList,
  platformScenesList,
  voicesList,
} from '@common';

const fetchBase = async <T>(
  url: string,
  method: 'POST' | 'PUT' | 'DELETE' | 'UPDATE' | 'GET' = 'GET',
  body?: T,
  extraHeaders?: Record<string, string>
) => {
  const response = await fetch(process.env.NX_PUBLIC_BACKEND_HOST + apiPrefix + url, {
    method,
    credentials: 'include',
    headers: {
      ...(body ? { 'Content-Type': 'application/json' } : {}),
      ...extraHeaders,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => {
      return { message: `Request failed with status ${response.status}` };
    });
    throw errorData; 
  }

  return response;
};

const fetchBaseWithFormData = (
  url: string,
  method: 'POST' | 'PUT' | 'DELETE' | 'UPDATE' | 'GET' = 'GET',
  formData: FormData
) => {
  return fetch(process.env.NX_PUBLIC_BACKEND_HOST + apiPrefix + url, {
    method,
    credentials: 'include',
    headers: {},
    body: formData,
  });
};

export const addPicture = (formData: FormData) => {
  return fetchBaseWithFormData(addPictureRoute, 'POST', formData);
};

export const updateAvatar = async (
  body: Partial<TAvatar & { _id?: string }>
) => {
  return fetchBase(avatarRouteUpdate, 'POST', {
    avatar: body,
    avatarId: body._id,
  });
};

export const listAvatars = async () => {
  return fetchBase(avatarRouteList, 'GET');
};

export const listVoices = async () => {
  return fetchBase(voicesList, 'GET');
};

export const login = async (name: string, pass: string) => {
  return fetchBase(loginRoute, 'POST', {
    name,
    pass,
  });
};

export const deleteAvatar = async (id?: string) => {
  return fetchBase(avatarRouteDelete, 'DELETE', {
    id,
  });
};

export const listPlatformAvatars = async () => {
  return fetchBase(platformAvatarsList, 'GET');
};

export const listPlatformScenes = async () => {
  return fetchBase(platformScenesList, 'GET');
};

export const fetchBrainData = async (promptText: string) => {
  const tenantId = "visperStudio";
  return fetchBase<{ promptText: string }>(avatarBrainService, 'POST', {
    promptText,
  }, {
    'Tenant-Id': tenantId,
  });
};
